import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Flex } from 'roo-ui/components';
import { useDraggable } from 'hooks/useDraggable';

const Swipeable = ({ swipeNext, swipePrev, children, ...rest }) => {
  const ref = useRef(null);

  useDraggable(ref, {
    onSwipeRightEnd: () => swipePrev(),
    onSwipeLeftEnd: () => swipeNext(),
  });

  return (
    <Flex {...rest} ref={ref}>
      {children}
    </Flex>
  );
};

Swipeable.propTypes = {
  children: PropTypes.node,
  swipeNext: PropTypes.func,
  swipePrev: PropTypes.func,
};

Swipeable.defaultProps = {
  children: null,
  swipeNext: noop,
  swipePrev: noop,
};

export default Swipeable;
